<header class="app-header">
  <div class="app-header__left">
    <img src="assets/img/spectrum-logo-white.png" alt="Spectrum Reach" class="app-header__logo" />
    <span class="app-header__divider"></span>
    <span class="app-header__title">PPT Agent</span>
  </div>
  <nav class="app-header__nav">
    <a routerLink="/sessions" routerLinkActive="app-header__nav-link--active" class="app-header__nav-link">
      Active Sessions
    </a>
    <a routerLink="/library" routerLinkActive="app-header__nav-link--active" class="app-header__nav-link">
      Library
    </a>
  </nav>
</header>

<main class="app-content">
  <router-outlet></router-outlet>
</main>

<footer class="app-footer">
  <img src="assets/img/spectrum-logo-gray.svg" alt="Spectrum Reach" class="app-footer__logo" />
  <span class="app-footer__copyright">&copy; {{ currentYear }} Charter Communications. All rights reserved.</span>
</footer>

<app-toast></app-toast>
